import React from 'react'
import Navbar from '../../Components/Navbar'
import PCBheader from '../../Components/PCBheader'
import PCBasembly from '../../Components/PCBasembly'
import Footer from '../../Components/Footer'

const PCB = () => {
  return (
    <div>
      <Navbar/>
      <PCBheader/>
      <PCBasembly/>
      <Footer/>
      
    </div>
  )
}

export default PCB
